export class DeviceModel {
    Id: number;
    CategoryId: number;
    IconName: string;
    MobileRemotes: boolean;
    LocalInputs: number;
    LocalOutputs: number;
    MaxAutomations: number;
    MaxSubGateways: number;
    AvailableServices: number[];
    SignalLevel?: boolean;
    BoardName?: string;
    BoardClass?: number;
    BoardId?: number;
    BoardInputs?: number;
    BoardOutputs?: number;
    CategoryName: string;
    Description: string;
    ProductName: string;
    ProductBoardName: string;
    Sharable: boolean;
    Vpn: boolean;
    /** Optional patches for ProductName/Description when Condition (e.g. BoardType) matches. */
    Patches?: DeviceModelPatch[];
}

export interface DeviceModelPatchCondition {
    BoardType?: string;
}

export interface DeviceModelPatchFields {
    ProductName?: string;
    Description?: string;
}

export interface DeviceModelPatch {
    Condition: DeviceModelPatchCondition;
    Patch: DeviceModelPatchFields;
}

export class NewDeviceModel {
    Id?: number;
    CategoryId?: number;
    IconName?: string;
    ProductName?: string;
    Description?: string;
    Vpn?: boolean;
    SignalLevel?: boolean;
    Sharable?: boolean;
    MobileRemotes?: boolean;
    LocalInputs?: number;
    LocalOutputs?: number;
    MaxAutomations?: number;
    MaxSubGateways?: number;
    BoardClass?: number;
    BoardId?: number;
    BoardName?: string;
    BoardProductName?: string;
    BoardProductCode?: string;
    BoardPower?: string;
    BoardDescription?: string;
    BoardInputs?: number;
    BoardOutputs?: number;
    MotorProductCode?: string;
    MotorPower?: string;
    MotorDescription?: string;
    SeriesName?: string;
    AutomationTypeName?: string;
}
